import React, { useEffect } from 'react';
import './App.css';
import Layout from './layouts/Layout';
import AnonyLayout from './layouts/AnonyLayout';
import { menus, anonyMenus } from './layouts/menus';
import { useDispatch, useSelector } from "react-redux";
import { LOGIN, LOGOUT, CHATALL } from "./services/actions";
import { useNavigate, useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let auth = useSelector((state) => state?.loginState?.auth)
  React.useEffect(() => {
    dispatch({ type: `${LOGIN}_AUTH`, payload: null, local: true });
    if (localStorage?.selectedTheme == "dark") {
      document.body.classList.add("dark")
    } else {
      document.body.classList.remove("dark")
    }
  }, [])

  React.useEffect(() => {
    //console.log("AUTH", JSON.stringify(auth))
    if (!auth) { onLogout() }
  }, [localStorage.getItem("auth")])
  const onLogout = () => {
    dispatch({ type: `${LOGOUT}_AUTH`, payload: null });
    navigate("/")
  }
  let isloaded = false;
  React.useEffect(() => {
    if (auth?.token && !isloaded) {
      const eventSource = new EventSource(
        `https://demo.widelapse.com/api/messages/sse/${auth?.id}/`
      );
      eventSource.onopen = () => {
        console.log("Connection to server opened.");
        isloaded = true;
      };
      eventSource.onmessage = (event) => {

        if (event.data === "[DONE]") {
          // eventSource.close();
        } else {
          let fixed = event.data
            .replace(/'/g, '"') // replace single quotes with double quotes
            .replace(/\bFalse\b/g, "false")
            .replace(/\bTrue\b/g, "true");
          fixed = fixed.replaceAll("None", "null");
          let parsed = JSON.parse(fixed);
          console.log("running", parsed.length);
          //setMessages((prev) => [...prev, parsed]);
          dispatch({ "message": "", "type": CHATALL + "_SUCCESS", "data": parsed });
        }
      };

      eventSource.onerror = (err) => {
        console.error("SSE error:", err);
        eventSource.close();
      };

      // cleanup on unmount
      return () => {
        eventSource.close();
      };
    }
  }, []);

  return (<>

    <ScrollToTop />
    {auth?.token && <Layout menus={menus}
      onLogout={() => { onLogout() }}
      appName={<label style={{ fontWeight: 800 }} className="text-center">{"Widelapse Core"}</label>}
      ispushsidebar={true}
    />}
    {!auth?.token && <AnonyLayout menus={anonyMenus} />}
  </>
  );
}

export default App;
